import {Component} from 'react'
import renderRoutes from 'react-router-config/es/renderRoutes'
import connect from 'react-redux/es/connect/connect'
import {bindActionCreators} from 'redux'
import { clone } from '../../../shared/services/lodashInJS.js'

import actions from '../Errors/actions.js'

class OfferContainer extends Component {
  liftOffer = (_offer) => {
    const offer = clone(_offer)
    offer.city = Array.isArray(offer.city) ? offer.city : [offer.city]
    if (offer.keywords) {
      offer.keywords = offer.keywords.map((object) => ({name: object}))
    }

    if (offer.secteurs) {
      offer.secteurs = offer.secteurs.map((object) => ({name: object}))
    }

    return offer
  }

  flattenOffer = (_offer) => {
    const offer = clone(_offer)
    if (offer.id) {
      offer.offer = offer.id
    }

    offer.city = Array.isArray(offer.city) ? offer.city[0].id : offer.city

    if (offer.keywords && offer.keywords.length > 0) {
      offer.keywords = offer.keywords.map(object => object.name)
    }
    if (offer.secteurs && offer.secteurs.length > 0) {
      offer.secteurs = offer.secteurs.map(object => object.name)
    }

    return offer
  }

  render() {
    return (
      renderRoutes(this.props.route.routes, {
        flattenOffer: this.flattenOffer,
        freelance: this.props.freelance,
        liftOffer: this.liftOffer,
        loading: !this.props.currentUser,
        currentUser: this.props.currentUser,
        userNotFound: this.props.userNotFound,
      })
    )
  }
}

export default connect(
  (state) => ({
    freelance: state.currentUser.freelance,
    currentUser: state.currentUser.user,
    userNotFound: state.errors.userNotFound,
  }),
  (dispatch) => bindActionCreators({...actions}, dispatch)
)(OfferContainer)